import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TrafficLightColor } from '../../../analysis/models/criterions/TrafficLightColor';

@Component({
    selector: 'sera-ri-shi',
    templateUrl: './sera-ri-shi.component.html',
    styleUrls: ['./sera-ri-shi.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraRiShiComponent {
    @Input()
    styleClass!: string;

    @Input()
    label!: string;

    @Input()
    value!: number | undefined | null;

    @Input()
    color!: TrafficLightColor | undefined | null;

    @Input()
    hideValue: boolean = false;
}
